import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import { useClearCache, } from '@herowcode/react-clear-cache';

import Forgotten from './pages/ForgottenPassword';
import Reset from './pages/ResetPassword';
import Migration from './pages/Migration';
import PasswordSent from './pages/PasswordSent';
import { Error404 } from './pages/Errors';

import { Loader, Spinner, Text } from "./components/ui";


function App() {

  const { latestVersion, isLatestVersion, emptyCacheStorage } = useClearCache({ filename: 'user-profile/meta.json' });
  if (!!latestVersion && !isLatestVersion) {
    setTimeout(() => {
      emptyCacheStorage();
    }, 2000);
    return (
      <>
        <Spinner classes={['mx-auto my-10']} />
        <Text className={`mt-10 text-lg text-center text-blue-600`} ><a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            emptyCacheStorage();
          }}
        >Click here to Refresh </a> if the page doesn't refresh in the next couple of seconds.
        </Text>
      </>
    );
  }

  return (
    <Router basename="/user-profile">
      <Switch>
        <Route path="/forgotten-password" component={Forgotten} />
        <Route path="/reset-password/:id?" component={Reset} />
        <Route path="/migration/:email?" component={Migration} />
        <Route path="/password-sent" component={PasswordSent} />
        {/* <Route path="/change-password" /> */}

        <Route path="/*" component={Error404} />
      </Switch>
    </Router>
  );
}

export default App;
